import { Component, Inject, Input, OnInit } from '@angular/core';
import { FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { GobalFunctionService } from 'src/app/core/services/gobal/gobal-function.service';

@Component({
  selector: 'lifedi-question-ranking',
  templateUrl: './question-ranking.component.html',
  styleUrls: ['./question-ranking.component.scss']
})
export class QuestionRankingComponent implements OnInit {
  @Input() rankingForm: FormGroup;
  @Input() isEditValue: boolean;
  modalData: any;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private fb: FormBuilder,
    private gbFunction: GobalFunctionService
  ) {
    this.modalData = data;
  }

  ngOnInit(): void {
    if (this.isEditValue) {
      // console.log(this.modalData);
      // console.log(this.rankingFormArray.value);
      for (let i = 0; i < this.modalData.value.VALUE[0].choices.length; i++) {
        this.rankingFormArray.push(
          this.fb.group({
            choice_id: [this.modalData.value.VALUE[0].choices[i].choice_id, Validators.required],
            choice_detail: [this.modalData.value.VALUE[0].choices[i].choice_detail, Validators.required]
          })
        )
      }
    }
  }

  addChoice(form) {
    form.push(
      this.fb.group({
        choice_id: form.value.length + 1,
        choice_detail: ['', Validators.required]
      })
    );
  }

  get rankingFormArray(): FormArray {
    return this.rankingForm.get('choices') as FormArray;
  }

  // สำหรับ multi ใช้ลบคำถามย่อย
  deleteChoice(form, index) {
    form.removeAt(index);

    form.value.map((f, index) => {
      f.choice_id = index + 1;
    })
  }
}
